import { Subject } from "rxjs"


export default (() => {
    const SUB = new Subject<string>();
    return SUB;
})();